/**
 * useIsVisible — returns `false` when the browser tab/window is hidden.
 *
 * Uses the Page Visibility API so that polling hooks can pause fetching
 * while the user isn't looking at the page, saving bandwidth at scale.
 */

import { useSyncExternalStore } from "react";

function subscribe(callback: () => void): () => void {
  document.addEventListener("visibilitychange", callback);
  return () => document.removeEventListener("visibilitychange", callback);
}

function getSnapshot(): boolean {
  return document.visibilityState === "visible";
}

function getServerSnapshot(): boolean {
  return true;
}

export function useIsVisible(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
